import React, { useRef } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from 'chart.js'
import { Bar, getElementAtEvent } from 'react-chartjs-2'
import { brandColors, chartSettings } from '../common/const'

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface ActiveCounterChartProps {
  labels: string[]
  dataSet: number[]
  chartTitle: string
  dataLabel: string
  onClick?: (index: number) => void
}

export const ActiveCounterChart: React.FC<ActiveCounterChartProps> = ({
  labels, dataSet, chartTitle, dataLabel, onClick
}) => {
  const data: ChartData<'bar'> = {
    labels,
    datasets: [
      {
        label: dataLabel,
        data: dataSet,
        backgroundColor: brandColors.normal,
        borderWidth: 0,
        borderRadius: 2,
      },
    ]
  }

  const chartRef = useRef()

  const onBarClick = (event: React.MouseEvent<HTMLCanvasElement>) => {
    if (!chartRef.current || !onClick) return
    const elements = getElementAtEvent(chartRef.current, event)
    if (elements.length > 0) onClick(elements[0].index)
  }

  return <Bar ref={chartRef} data={data} options={{
    responsive: true,
    plugins: {
      legend: { position: 'bottom' },
      title: { display: true, text: chartTitle },
    },
    scales: {
      x: { stacked: false },
      y: { stacked: false },
    },
  }} {...chartSettings} onClick={onBarClick} />
}
